import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { from, Observable, switchMap } from 'rxjs';
import { environment } from 'src/environments/environment.local';
import { CredentialService, SecuritySession } from 'src/app/order/services/internal/security/credential.service';
import { buildCanonical } from './canonicalizer';
import { hmacSha256Base64, importHmacKey } from './crypto.util';   // ← removido sha256Base64
import { SecurityConfig } from './security.config';

@Injectable()
export class SigningInterceptor implements HttpInterceptor {
  constructor(private credentialService: CredentialService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (!environment.security?.enabled || this.isSkip(request.url)) {
      return next.handle(request);
    }
    return from(this.signIfReady(request)).pipe(switchMap((signed) => next.handle(signed)));
  }

  private isSkip(url: string): boolean {
    return SecurityConfig.skip.some((path) => url.includes(path));
  }

  private async signIfReady(request: HttpRequest<any>): Promise<HttpRequest<any>> {
    await this.credentialService.whenReady();

    const session = this.credentialService.current();
    if (!session) {
      return request;
    }
    return this.sign(request, session);
  }

  private async sign(request: HttpRequest<any>, session: SecuritySession): Promise<HttpRequest<any>> {
    const u = new URL(request.urlWithParams, window.location.origin);
    const urlWithParams = u.pathname + u.search;

    const nonce = crypto.randomUUID();

    const canonical = buildCanonical(request.method, urlWithParams, nonce);

    const key = await importHmacKey(session.sessionKey);
    const signature = await hmacSha256Base64(key, canonical);

    const h = SecurityConfig.headers;
    return request.clone({
      setHeaders: {
        [h.session]: session.sessionId,
        [h.nonce]: nonce,
        [h.signature]: signature,
      },
    });
  }
}
